import dayjs from "dayjs";
import "dayjs/locale/pt-br";

export default {
  data() {
    return {
      items: [],
    };
  },
  props: [
    "loading",
    "anexos",
    "docCur",
    "docDate",
    "docRate",
    "docDueDate",
    "docEntry",
    "docTotal",
    "docTotalReais",
    "itens",
    "requester",
    "department",
    "docNum",
    "saving",
    "comments",
    "alba_Comments",
    "cardName",
    "pymntGroup",
    "despesasAdicionals",
    "buyer",
  ],
  watch: {
    itens(newValue) {
      this.items = newValue;
    },
  },
  methods: {
    formattedPrice(price, symbol = "GS", options = {}) {
      const currencies = {
        R$: "BRL",
        GS: "PYG",
        USD: "USD",
        CAN: "CAD",
        EUR: "EUR",
        RMB: "CNY",
      };

      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: currencies[symbol],
        ...options,
      }).format(price);
    },
    formattedDate(date) {
      return dayjs(date).format("DD/MM/YYYY");
    },
  },
};
